<template>
    <div>
        <b-card no-body class="mb-1">
            <v-table    ref="table" 
                        :fields="fields"
                        with-items
                        :items="datas"
                        pagination="client"
                        :settings="false">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-3 mb-1 mb-md-0">             
                                    <b-input-group class="input-group-merge">
                                        <template #prepend>
                                            <b-input-group-text >
                                                <feather-icon icon="SearchIcon"></feather-icon>
                                            </b-input-group-text>
                                        </template>
                                        <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                                    </b-input-group>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success btn-block" v-on:click="getData" :disabled="getting">
                                        Şablon Oluştur
                                    </button>
                                </div>
                                <div class="col-md-auto ml-auto">
                                    <b-dropdown text="İşlemler" right variant="primary" v-if="basicExcelPath">
                                        <b-dropdown-item v-on:click="downloadBasicExcel">
                                            <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                            Basit Excel İndir
                                        </b-dropdown-item>
                                        <b-dropdown-item v-on:click="downloadDetailedExcel">
                                            <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                            Detaylı Excel İndir
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                        </template>
                    </v-table>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>

</template>

<script>
import { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'

export default{
    components:{
        BCard,
        BInputGroup, 
        BInputGroupText, 
        BFormInput,
        BDropdown, 
        BDropdownItem
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    data(){
        return {
            fields:[
                {name:'Sıra',key:'OrderNumber',tdClass:'text-nowrap'},
                {name:'Personel',key:'FullName',tdClass:'text-nowrap',sticky:true},
                {name:'Kimlik No',key:'IdentityNumber',tdClass:'text-nowrap'},
                {name:'IBAN',key:'IBAN',tdClass:'text-nowrap'},
                {name:'SGK Şube',key:'SGKBranchName',tdClass:'text-nowrap'},
                {name:'Sabit Maaşı',key:'GSalaryStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Giriş Tarihi',key:'SGKEntryDateStr',tdClass:'text-nowrap'},
                {name:'Çıkış Tarihi',key:'SGKExitDateStr',tdClass:'text-nowrap'},
                {name:'Yıllık İzin',key:'YILLIK_IZIN',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Ücretli İzin',key:'UCRETLI_IZIN',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Diğer Eksik Gün',key:'DIGER_EKSIK_GUN',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Çalışma Kazancı',key:'CALISMA_KAZANCIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Agi',key:'AGIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Toplam Maaş',key:'TOPLAM_MAASStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Yıllık İzin Kazanç',key:'YILLIK_IZIN_KAZANCStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Toplam Hakediş',key:'TOPLAM_HAKEDISStr',tdClass:'text-nowrap  text-right',thClass:'vt-th-text-right'},
                {name:'Önceki Ay Toplam Hakediş',key:'ONCEKI_AY_TOPLAM_HAKEDISStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Bankaya Yatan',key:'BANKAYA_YATANStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'İcra',key:'ICRAStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Bes',key:'BESStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Avans',key:'AVANSStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Trafik Cezası ve Kesinti',key:'TRAFIK_CEZAveKESINTIStr',tdClass:'text-nowrap text-right',thClass:'vt-th-text-right'},
                {name:'Hatalar',key:'Errors',tdClass:'text-danger text-nowrap'}
            ],
            datas:[],
            basicExcelPath:null,
            detailedExcelPath:null,
            searchValue:'',
            getting:false
        }
    },
    methods:{
        getData(){
            this.$confirm('Sorgu çalıştırmak istediğinizden emin misiniz?','Yeni şablon oluşturma işlemi, varsa önceden oluşturup düzenleme yaptığınız bilgileri filtreye göre silecektir. Yine de devam etmek istiyor musunuz?').then(c => {
                if(c){
                    this.$refs.table.setLoading(true)
                    this.getting = true
                    EmployeeOperationsApi.GSalary.Excel({
                        ...this.filter,
                        PaginateRequest:{
                            QueryParam: this.searchValue
                        }
                    }).then(res => {
                        if(res.data.Success){
                            this.datas = res.data.Data.Data?.map(d => ({...d,Errors:(d.Errors || []).join(', ')}))
                            this.basicExcelPath = res.data.Data.BasicExcelPath
                            this.detailedExcelPath = res.data.Data.DetailedExcelPath
                        }else{
                            this.$result(res)
                        }
                        this.$refs.table.setLoading(false)
                        this.getting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.$refs.table.setLoading(false)
                        this.getting = false
                    })
                }
            })
        },
        downloadBasicExcel(){
            if(this.basicExcelPath){
                Additional.DownloadTab(this.basicExcelPath)
            }
        },
        downloadDetailedExcel(){
            if(this.detailedExcelPath){
                Additional.DownloadTab(this.detailedExcelPath)
            }
        }
    }
}
</script>